export function AnnouncementBar() {
  return (
    <div className="bg-charcoal text-white text-center" style={{ height: "36px", lineHeight: "36px" }}>
      <p className="text-[11px] font-medium tracking-wide">
        Free Shipping on Orders over 299 zl - Easy Returns.
      </p>
    </div>
  );
}
